import { baxi_colors, valtec } from 'console/theme/styles/colors/brands';
export const additionalColors = {
    palette: {
        neutral_dark: {
            light: '#a3b6d1',
            main: '#64748B',
            dark: '#39495e',
            contrastText: '#fff',
        },
        neutral_light: {
            light: '#ffffff',
            main: '#EBEBEB',
            dark: '#DBDBDB',
            contrastText: '#0f0f0f',
        },
        neutral: {
            light: '#ebebeb',
            main: '#939393',
            dark: '#a4a4a4',
            contrastText: '#0f0f0f',
        },
        autoscan: {
            light: '#60dffd',
            main: '#05adca',
            dark: '#007d99',
            contrastText: '#0f0f0f',
        },
        security: {
            light: '#b5d261',
            main: '#a3c73a',
            dark: '#728b28',
            contrastText: '#0f0f0f',
        },
        heat: {
            light: '#f48458',
            main: '#f0801e',
            dark: '#e06d04',
            contrastText: '#f0f0f0',
        },
        car: {
            light: '#56c8cb',
            main: '#2cbbbf',
            dark: '#1e8285',
            contrastText: '#0f0f0f',
        },
        valtec: valtec.primary,
        baxi: baxi_colors(false).primary,
    },
};
export const additional_colors = Object.keys(additionalColors.palette);
